import React from 'react';

/** Loading skeletons for the VOD grid. */
const VodGridSkeleton: React.FC = () => {
  return (
    <div
      className="studio-vods-grid"
      data-testid="studio-vods-loading"
      aria-busy="true"
      aria-label="Loading VODs"
    >
      {Array.from({ length: 6 }).map((_, i) => (
        <div key={i} className="rounded-lg overflow-hidden border border-white/5">
          <div className="studio-skeleton aspect-video" />
          <div className="p-3 space-y-2">
            <div className="studio-skeleton h-4 w-4/5" style={{ width: '80%' }} />
            <div className="studio-skeleton h-3 w-1/3" style={{ width: '33%' }} />
          </div>
        </div>
      ))}
    </div>
  );
};

export default VodGridSkeleton;
